var _rect, _path, _path2, _line, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationShipmentBooked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.06348,
    y: 7.82764,
    width: 26.8726,
    height: 26.8726,
    rx: 2.75,
    stroke: "white",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0488 5L13.0488 7.28453",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7129 5L28.7129 7.28453",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.79297,
    y1: 14.1392,
    x2: 34.2074,
    y2: 14.1392,
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2374 29.2141C19.6218 29.1821 19.9734 28.9852 20.2015 28.6742L25.7418 21.1213C26.1772 20.5277 26.049 19.6935 25.4554 19.2581C24.8618 18.8227 24.0276 18.9509 23.5921 19.5445L18.958 25.8621L16.9499 23.9089C16.4222 23.3956 15.5783 23.4073 15.065 23.935C14.5517 24.4627 14.5633 25.3066 15.0911 25.8199L18.1973 28.8413C18.4737 29.1102 18.8531 29.2462 19.2374 29.2141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationShipmentBooked);
export default __webpack_public_path__ + "static/media/notification-shipment-booked.169c5d26ee66ddceb2b721561960726a.svg";
export { ForwardRef as ReactComponent };